import SiteMapping from '../configs/siteMapping';

const headerLayout = {
    layout789y: [SiteMapping.viva88, SiteMapping.bong88],
    layoutNova88: [SiteMapping.Nova88, SiteMapping.PICA88,
        SiteMapping.IBCBet, SiteMapping.id8899, SiteMapping.bettha88, SiteMapping.taraPlays,
        SiteMapping.fifabet, SiteMapping.ocean99],
    layoutSupportCasino: [SiteMapping.Nova88, SiteMapping.IBCBet, SiteMapping.fifabet, SiteMapping.ocean99],
};

export default headerLayout;
